import React from "react";
import WarehouseCard from "./WarehouseCard";

const WarehousePanel = ({ product }) => {
  return (
      <tr>
        <td colSpan={6} className="bg-white px-3 py-2">
          <div className="max-w-full overflow-x-auto">
            <div className="min-w-0">
              {product.warehouses.map((warehouse) => (
                  <WarehouseCard
                      key={warehouse.id}
                      product={product}
                      warehouse={warehouse}
                  />
              ))}
            </div>
          </div>
        </td>
      </tr>
  );
};

export default WarehousePanel;